import { render, staticRenderFns } from "./GroupedFormSubmissions.vue?vue&type=template&id=5cd89c26&scoped=true&"
import script from "./GroupedFormSubmissions.vue?vue&type=script&lang=js&"
export * from "./GroupedFormSubmissions.vue?vue&type=script&lang=js&"
import style0 from "./GroupedFormSubmissions.vue?vue&type=style&index=0&id=5cd89c26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd89c26",
  null
  
)

export default component.exports